import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'

class ReceiveCouponForLiveStore extends StoreExt {
    @observable title = '获取验证码'
    @observable lockForClick: boolean = false
    @observable couponInfo: any = {}
    private timer: any
    private lock: boolean = false // 控制是否倒计时中

    @action
    getActivityInfo = async (param) => {
        let couponInfo = null
        try {
            couponInfo = await this.api.queryStreamCouponInfo(param)
        } catch (e) {
            couponInfo = null
        } finally {
            runInAction(() => {
                this.couponInfo = couponInfo
            })
        }
    }

    @action
    receiveCoupon = async (phone, code, activityId) => {
        try {
            runInAction(() => {
                this.lockForClick = true
            })
            await this.api.verifyMsgCode({phone, code})
            await this.api.receiveCouponCode({phone, activityId})
            setTimeout(() => {
                this.$modal.alert('领取成功', '兑换码已发送至手机，请注意查收短信', [{
                    text: '确认',
                    style: {color: '#eb6a1a'}
                }])
                clearInterval(this.timer)
                runInAction(() => {
                    this.lockForClick = false
                    this.title = '重新获取'
                    this.lock = false
                })
            }, 2000)
        } catch (e) {
            const iCodeInfoObj = {
                'USS-0181': '验证码错误或失效',
                'i0105': '没有领取次数了',
                'i0106': '券已经领完了',
                'default': e.err.msg || '未知异常，请稍后再试'
            }
            this.$toast.info(iCodeInfoObj[e.err.iCode || 'default'])
            runInAction(() => {
                this.lockForClick = false
            })
        }
    }

    @action
    getPhoneCode = async (phone) => {
        if (this.lock) {
            return
        }
        let baseTimer = 60
        this.lock = true
        runInAction(() => {
            this.title = '60秒后重新获取'
        })
        this.timer = setInterval(() => {
            baseTimer--
            if (baseTimer <= 0) {
                clearInterval(this.timer)
                this.lock = false
            }
            runInAction(() => {
                this.title = baseTimer <= 0 ? '重新获取' : `${baseTimer}秒后重新获取`
            })
        }, 1000)
        let toastText = ''
        try {
            await this.api.sendMsg({phone})
            toastText = '发送成功'
        } catch (e) {
            toastText = '发送失败'
        } finally {
            this.$toast.info(toastText)
        }
    }
}

const receiveCouponForLiveStore = new ReceiveCouponForLiveStore()
export {receiveCouponForLiveStore, ReceiveCouponForLiveStore}
